<template>

    <div class="index">

        <div class="active-detail">

            <div class="star-nav ">

                <span class="pointer" @click="openIndex">活动</span>

                <span> / </span>

                <span>活动详情</span>

            </div>

            <div class="active-post cf">

                <v-image class="fl active-post-img" :src="info.picture" />

                <div class="fl active-post-box">

                    <div class="active-title">{{ info.title }}</div>

                    <div v-if="type == 1" class="active-info">

                        <div class="active-info-top cf">

                            <div class="fl">已分享</div>

                            <div class="fr active-info-top-right"><span>{{ info.share_count || 0 }}</span>次</div>

                        </div>

                    </div>

                    <div v-else class="active-info">

                        <div class="active-info-top cf">

                            <div class="fl">已获得支持</div>

                            <div class="fr active-info-top-right"><span>{{ info.raise_count }}</span>次</div>

                        </div>

                        <div class="active-progress">

                            <el-progress :percentage="percentage" color="#8F5FF5" :show-text="false"/>

                        </div>

                        <div class="active-mb">目标：{{ info.target }}次</div>

                    </div>

                    <div class="active-floor">活动内容：<span>{{ type == 1 ? '福利' : '应援' }}</span></div>

                    <div class="active-floor">参与人数：<span>{{ info.join_count }}</span></div>

                    <div class="active-floor margin">结束时间：<span>{{ info.end_time }}</span></div>

                    <div
                        class="active-btn button-active"
                        :class="[ info.status === 2 ? 'button' : 'disabled_button' ]"
                        @click="openPop"
                    >
                        {{ info.status === 1 ? '活动未开始' : info.status === 2 ? '我要参与' : '活动已结束' }}
                    </div>

                </div>

            </div>

            <div class="active-content">

                <div class="active-left">

                    <div class="active-header">活动详情</div>

                    <div class="active-text v-html" v-html="info.content"></div>

                </div>

            </div>

        </div>

    </div>

</template>

<script>
import mixin from "./mixin/mixin";
import vImage from '@/components/image';
export default {
    name: "active-detail",
    mixins: [mixin],
    components:{
        vImage
    }
}
</script>

<style scoped src="./style.css"></style>
